import { createAction } from 'redux-actions';
const namespace = 'LAYOUT';

export const setProcessingLoaderVisibility = createAction(`${namespace}/SET_PROCESSING_LOADER_VISIBILITY`);
export const setGeneratingLoaderVisibility = createAction(`${namespace}/SET_GENERATING_LOADER_VISIBILITY`);
export const setGeneratingLoaderProgress = createAction(`${namespace}/SET_GENERATING_LOADER_PROGRESS`);
export const setStarterLoaderVisibility = createAction(`${namespace}/SET_STARTER_LOADER_VISIBILITY`);
export const setGoAppModalVisibility = createAction(`${namespace}/SET_GO_APP_MODAL_VISIBILITY`);
export const setSidebarVisibility = createAction(`${namespace}/SET_SIDEBAR_VISIBILITY`);